import { ErrorModalTypes, useBoundStore } from '@Store/index';
import { NoticeModal, Text } from '@lili/lili-frontend-common';
import { Icon, Icons } from '@Components/icon/Icon';
import { useCallback } from 'react';
import { t } from 'i18next';

export const ModalManager = () => {
  const { setErrorModal, errorModal } = useBoundStore((state) => state.errorSlice);

  const handleSubmit = useCallback(() => {
    setErrorModal({ error: '', modalProps: undefined });
    if (errorModal.modalProps?.onSubmit) {
      errorModal.modalProps.onSubmit();
    }
  }, [errorModal.modalProps, setErrorModal]);

  const renderModal = useCallback(() => {
    const content = (
      <div className='flex  justify-center items-center mb-[48px] gap-1'>
        <Text.H10>
          {errorModal?.modalProps?.content ?? t('enErrors:default.description')}
          {'  '}
        </Text.H10>
      </div>
    );

    switch (errorModal.modalProps?.type) {
      case ErrorModalTypes.GENERAL:
        return (
          <NoticeModal
            buttonText={errorModal.modalProps.buttonText || t('enErrors:default.button')}
            secondaryButtonText={errorModal.modalProps.button2Text}
            secondaryOnSubmit={errorModal.modalProps.onCancel}
            image={<Icon icon={errorModal.modalProps.icon ?? Icons.Oops} />}
            title={errorModal.modalProps.title ?? t('enErrors:default.title')}
            id='error-modal'
            content={content}
            onSubmit={handleSubmit}
            onClickOutside={handleSubmit}
            shouldPersist
          />
        );

      case ErrorModalTypes.CUSTOM:
        return errorModal?.modalProps?.cmp ? errorModal.modalProps.cmp() : null;

      default:
        return null;
    }
  }, [errorModal.modalProps, handleSubmit]);

  return renderModal();
};
